var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"progress-container"},[_c('div',[_c('el-progress',_vm._b({attrs:{"type":_vm.type}},'el-progress',_vm.$attrs,false)),_c('h3',[_vm._v(_vm._s(_vm.message))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }